import { IObservable, Subject } from '~/rage/utils';
import { IClientConfigs } from '~/shared';

export abstract class AbstractVehiclePaintShopService {
	protected paintTypes = new Subject<IClientConfigs['vehiclesPaint']['types']>(
		[],
	);
	protected pearlColors = new Subject<
		IClientConfigs['vehiclesPaint']['paintColors']
	>([]);
	protected indexedColors = new Subject<
		IClientConfigs['vehiclesPaint']['paintColors']
	>([]);
	protected rimsColors = new Subject<
		IClientConfigs['vehiclesPaint']['rimsColors']
	>([]);
	protected brakesColors = new Subject<
		IClientConfigs['vehiclesPaint']['brakesColors']
	>([]);
	protected rimsColorPrice = new Subject<number>(0);
	protected windowTints = new Subject<
		IClientConfigs['vehiclesPaint']['windowsTints']
	>([]);

	public getVehiclePaintTypes(): IObservable<
		IClientConfigs['vehiclesPaint']['types']
	> {
		return this.paintTypes;
	}

	public getVehiclePearlColors(): IObservable<
		IClientConfigs['vehiclesPaint']['paintColors']
	> {
		return this.pearlColors;
	}

	public getVehicleIndexedColors(): IObservable<
		IClientConfigs['vehiclesPaint']['paintColors']
	> {
		return this.indexedColors;
	}

	public getVehicleRimsColors(): IObservable<
		IClientConfigs['vehiclesPaint']['rimsColors']
	> {
		return this.rimsColors;
	}

	public getVehicleBrakesColors(): IObservable<
		IClientConfigs['vehiclesPaint']['brakesColors']
	> {
		return this.brakesColors;
	}

	public getVehicleRimsColorPrice(): IObservable<number> {
		return this.rimsColorPrice;
	}

	public getVehicleWindowTints(): IObservable<
		IClientConfigs['vehiclesPaint']['windowsTints']
	> {
		return this.windowTints;
	}
}
